export enum BusinessUnitKey {
  Flokee = 'FLOKEE',
  Cleepo = 'CLEEPO',
}

export interface BusinessUnitConfig {
  key: BusinessUnitKey;
  label: string;
  // Route prefix for this BU namespace (e.g. /flokee).
  basePath: string;
  // Production domain that implies this BU.
  domain?: string;
  // Route name to redirect unauthenticated users to this BU login.
  loginRouteName: string;
  // Backend BU value (uppercase) used in API payloads.
  businessUnitValue: BusinessUnitKey;
  // Shared UI assets resolved by BU.
  logoPath: string;
  faviconPath: string;
}

export const BUSINESS_UNITS: BusinessUnitConfig[] = [
  {
    key: BusinessUnitKey.Flokee,
    label: 'Flokee',
    basePath: '/flokee',
    // Domain routing only applies in production.
    domain: import.meta.env.VITE_APP_FLOKEE_URL,
    loginRouteName: 'AuthLoginView',
    businessUnitValue: BusinessUnitKey.Flokee,
    logoPath: '/images/logo.svg',
    faviconPath: '/favicon/favicon-flokee.ico',
  },
  {
    key: BusinessUnitKey.Cleepo,
    label: 'Cleepo',
    basePath: '/cleepo',
    domain: import.meta.env.VITE_APP_CLEEPO_URL,
    loginRouteName: 'CleepoAuthLoginView',
    businessUnitValue: BusinessUnitKey.Cleepo,
    logoPath: '/images/cleepo-logo-green-blue.png',
    faviconPath: '/favicon/favicon-cleepo.ico',
  },
];

export function getBusinessUnitConfig(key_value: BusinessUnitKey | undefined) {
  if (!key_value) return undefined;
  return BUSINESS_UNITS.find((bu) => bu.key === key_value);
}
